module.exports = __webpack_public_path__ + "img/magnifying-glass.b9e0fef3.svg";